import { render } from "./B2BBillings.vue?vue&type=template&id=e7cc3a04&scoped=true"
import script from "./B2BBillings.vue?vue&type=script&lang=js"
export * from "./B2BBillings.vue?vue&type=script&lang=js"

import "./B2BBillings.vue?vue&type=style&index=0&id=e7cc3a04&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7cc3a04"]])

export default __exports__